import React from 'react';
import H3Text from '@Uilib/h3Text';

function ViewConsumptionAddressDetails({
  selectedInvoice
}) {
  return (
    <div className="document-address-list">
      <div className="ant-row">
        {!!selectedInvoice?.shipping_address_info && (<div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__left">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Ship To" className="document-address__title" />
            </div>
            {selectedInvoice?.shipping_address_info?.address1 && <H3Text text={selectedInvoice.shipping_address_info.address1} className="document-address__details" />}
            {selectedInvoice?.shipping_address_info?.address1 && (
              <H3Text
                text={`${selectedInvoice?.shipping_address_info?.city}, ${selectedInvoice?.shipping_address_info?.state}, ${selectedInvoice?.shipping_address_info?.postal_code}, ${selectedInvoice?.shipping_address_info?.country}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>)}
        {!!selectedInvoice?.ship_from_address_info && (<div className="ant-col-md-12 ant-col-xs-24">
          <div className="document-address__right">
            <div className="view-document__input-row__address-icon-wrapper">
              <H3Text text="Ship From" className="document-address__title" />
            </div>
            {selectedInvoice?.ship_from_address_info?.address1 && <H3Text text={selectedInvoice.ship_from_address_info.address1} className="document-address__details" />}
            {selectedInvoice?.ship_from_address_info?.address1 && (
              <H3Text
                text={`${selectedInvoice?.ship_from_address_info?.city}, ${selectedInvoice?.ship_from_address_info?.state}, ${selectedInvoice?.ship_from_address_info?.postal_code}, ${selectedInvoice?.ship_from_address_info?.country}`}
                className="document-address__details"
              />
            )}
          </div>
        </div>)}
      </div>
    </div>
  );
};

export default ViewConsumptionAddressDetails;